import React, { PropsWithChildren } from "react";
import styles from "./TutorialsList.module.scss";
import { strings } from "intl/fa";
import {
  MostVisitedArticles,
  MostVisitedVideos,
} from "./mainMenu/MostVisitedLists";
import { useAppDispatch } from "utils/store";
import {
  TutorialPages,
  TutorialsActions,
} from "core/tutorials/tutorials.slice";

function TutorialsList() {
  const dispatch = useAppDispatch();
  return (
    <div>
      {/* <Wrapper> */}
      {/* <Header title={strings.tutorials.title} /> */}
      <div className={styles.Content}>
        {/* TODO: <Section primaryText={strings.tutorials.sections.categories}>
            <Categories />
          </Section> */}
        <Section
          primaryText={strings.tutorials.sections.most_visited_articles}
          secondaryText={strings.tutorials.sections.show_all_articles}
          onSecondaryClick={() =>
            dispatch(TutorialsActions.setPage(TutorialPages.TutorialArticles))
          }
        >
          <MostVisitedArticles />
        </Section>
        <Section
          primaryText={strings.tutorials.sections.most_visited_videos}
          secondaryText={strings.tutorials.sections.show_all_videos}
          onSecondaryClick={() =>
            dispatch(TutorialsActions.setPage(TutorialPages.TutorialVideos))
          }
        >
          <MostVisitedVideos />
        </Section>
      </div>
      {/* </Wrapper> */}
    </div>
  );
}

export default TutorialsList;

type SectionProps = PropsWithChildren<{
  primaryText: string;
  secondaryText?: string;
  onSecondaryClick?: VoidFunction;
}>;

export function Section(props: SectionProps) {
  return (
    <div className={styles.Section}>
      <div className={styles.SectionTitle}>
        <div className={styles.PrimaryText}>{props.primaryText}</div>
        {props.secondaryText && (
          <div
            onClick={props.onSecondaryClick}
            className={styles.SecondaryText}
          >
            {props.secondaryText}
          </div>
        )}
      </div>
      {props.children}
    </div>
  );
}
